module.exports = __webpack_public_path__ + "static/logo-saigon-cafe@3x-97aa1f16917697bce72916e692879390.png";